enum ExploreSortOrder {
  Newest = "Newest",
  Oldest = "Oldest",
  HighestPrice = "HighestPrice",
  LowestPrice = "LowestPrice",
}

export default ExploreSortOrder;
